const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const PPC_SECRET = process.env.REACT_APP_PPC_EMAIL_API_SECRET || '';

function buildHeaders() {
  return {
    'Content-Type': 'application/json',
    ...(PPC_SECRET ? { 'x-ppc-secret': PPC_SECRET } : {}),
  };
}

async function parseResponse(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || 'Request failed');
  }
  return data;
}

export async function createEmployeeInvitation({ email, invitedBy }) {
  const response = await fetch(`${API_BASE}/api/auth/employee-invitations`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify({ email, invitedBy }),
  });
  return parseResponse(response);
}

export async function verifyEmployeeInvitationToken(token) {
  const query = new URLSearchParams({ token }).toString();
  const response = await fetch(`${API_BASE}/api/auth/employee-invitations/verify?${query}`, {
    method: 'GET',
    headers: buildHeaders(),
  });
  return parseResponse(response);
}

export async function consumeEmployeeInvitationToken({ token, email }) {
  const response = await fetch(`${API_BASE}/api/auth/employee-invitations/consume`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify({ token, email }),
  });
  return parseResponse(response);
}
